export default __webpack_public_path__ + "static/media/beerBG.a26617cc.jpg";